// removed by extract-text-webpack-plugin
module.exports = {"skus-item-text":"skus-item-text___9XWe6","skus-item-btnGroup":"skus-item-btnGroup___1zm-e","skus-item-btn-edit":"skus-item-btn-edit___25vZb","skus-item-btn-del":"skus-item-btn-del___rhlhc","skus-child-container":"skus-child-container___3eKrg","skus-child-addBtn-container":"skus-child-addBtn-container___3qVia","skus-child-addBtn-text":"skus-child-addBtn-text___1i7ID"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/SkusEdit/SkusItem/Index.less
// module id = /DBt
// module chunks = 10 11